import { Card } from "antd";
const { Meta } = Card;

const InformationCard = ({ feature, customClassName }) => {
  const { icon, title, description } = feature;

  return (
    <Card
      className={`icon-card group ${
        customClassName || ""
      } transition-all duration-300 ease-in-out hover:bg-[#FF6838]`}
      hoverable
    >
      <div className="icon-wrapper mb-4 justify-center flex items-center text-[#FF6838] group-hover:text-white transition-colors duration-300">
        {icon}
      </div>
      <Meta
        title={
          <span className="font-serif text-gray-800 group-hover:text-white transition-colors duration-300">
            {title}
          </span>
        }
        description={
          <span className="font-sans text-gray-600 group-hover:text-white transition-colors duration-300">
            {description}
          </span>
        }
      />
    </Card>
  );
};

export default InformationCard;
